﻿export const WMS_RATIO = 1;
export const CROSS_ORIGIN = 'anonymous';
export const WFS_VERSION = '1.0.0';
export const WFS_DEFAULT_LOADING_STRATEGY = 'bboxStrategy';
export const WFS_ALL_STRATEGY = 'allStrategy';
export const WFS_DEFAULT_DECLUTTER = false;
export const DEFAULT_SRID = 'EPSG:3857';
export const DEFAULT_MARK_SIZE = 16;
export const DEFAULT_MARK_FILL_COLOR = '#0000ff';
export const DEFAULT_MARK_FILL_OPACITY = 0.5;
export const DEFAULT_MARK_STROKE_COLOR = '#0000ff';
export const DEFAULT_MARK_STROKE_OPACITY = 1;
export const DEFAULT_MARK_STROKE_WIDTH = 1;
export const DEFAULT_MARK_ROTATION = 0;
export const DEFAULT_MARK_DISPLACEMENT_X = 0;
export const DEFAULT_MARK_DISPLACEMENT_Y = 0;
export const DEFAULT_MARK_ANCHOR_POINT_X = 0.5;
export const DEFAULT_MARK_ANCHOR_POINT_Y = 0.5;
export const DEFAULT_STYLE_ONLINE_RESOURCE = '/img/sld/animals.png';
export const ENTITY_TYPE_NAME_PREFIX = 'LYR_';